import keycloakService from '../../keycloak_service';

import { getTimeRange } from '../date_utils';
import { postToSinatra } from '../api_utils';
import {
  ALL_TIME
} from '../../components/admin/orchestrations/OrchestrationTableFilterModal/OrchestrationTableFilterModal';

export const listAllOrchestrations = ({
  workspaceIds = [],
  taskRunStatuses = [],
  timeRange = undefined,
  killed = undefined,
}) => {
  const bodyObj = {
    workspace_ids: workspaceIds,
    task_run_status: taskRunStatuses,
  }

  if (killed !== undefined) {
    bodyObj.killed = killed;
  }

  if (timeRange !== undefined  && timeRange !== null && timeRange?.type !== ALL_TIME) {
    bodyObj.time_range = getTimeRange(timeRange);
  }
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(bodyObj)
  };

  return postToSinatra('v1/api/orchestration/list_all', fetchOptions)
}

export const swrListAllOrchestrations = (queryParams) => {
  const [
    workspaceIds, orchestrationStatusFilter, taskRunStatusFilter, timeRangeFilter,
  ] = queryParams;

  return listAllOrchestrations({
    workspaceIds,
    killed: orchestrationStatusFilter,
    taskRunStatuses: taskRunStatusFilter,
    timeRange: timeRangeFilter,
  })
}

export default listAllOrchestrations;
